export const prepararJanelaPdf = () => window.open('', '_blank');

export const exibirPdfBlob = (blob, janela) => {
    if (!janela) {
        throw new Error('O navegador bloqueou a abertura do relatório. Permita pop-ups e tente novamente.');
    }

    const arquivo = blob?.type === 'application/pdf'
        ? blob
        : new Blob([blob], { type: 'application/pdf' });
    const url = URL.createObjectURL(arquivo);
    janela.location.href = url;
    window.setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const fecharJanela = (janela) => {
    if (janela && !janela.closed) janela.close();
};

export const baixarBlob = (blob, nomeArquivo) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const criarNomeArquivo = (prefixo, extensao, data = new Date()) => {
    const doisDigitos = (valor) => String(valor).padStart(2, '0');
    const dataHora = `${data.getFullYear()}${doisDigitos(data.getMonth() + 1)}${doisDigitos(data.getDate())}`
        + `-${doisDigitos(data.getHours())}${doisDigitos(data.getMinutes())}${doisDigitos(data.getSeconds())}`;
    return `${prefixo}-${dataHora}.${extensao}`;
};
